import { SITE_CONFIG } from "@/config/site";

export const getImageUrl = (path: string) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;

  return `${SITE_CONFIG.IMAGE_BASE_URL}${path}`;
};

/**
 * Build a country-flag image URL. Flags live on a separate (legacy) CDN — see
 * SITE_CONFIG.COUNTRY_FLAG_BASE_URL. Pass the flag filename from countries.json
 * (e.g. "in.webp"); call with no argument to get the base directory URL.
 */
export const getFlagUrl = (flag = "") => {
  if (flag.startsWith("http")) return flag;
  return `${SITE_CONFIG.COUNTRY_FLAG_BASE_URL}${flag}`;
};